/* eslint-disable react/jsx-props-no-spreading */
import {
  useFloating,
  useInteractions,
  useHover,
  offset,
  flip,
  shift,
  arrow,
  autoUpdate,
} from '@floating-ui/react'
import { clsx } from 'clsx'
import { cloneElement, useState, useRef } from 'react'

import styles from './styles.module.scss'

export const CustomTippy = ({
  children,
  content,
  // className,
  placement = 'top',
  delay = 50,
  disabled = false,
  show,
  customWidth,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const arrowRef = useRef(null)

  //

  const isVisible = show || isOpen

  //

  const { refs, floatingStyles, context, middlewareData } = useFloating({
    open: isVisible,
    onOpenChange: setIsOpen,
    placement,
    middleware: [
      offset(8),
      flip(),
      shift({ padding: 5 }),
      // eslint-disable-next-line react-hooks/refs
      arrow({ element: arrowRef }),
    ],
    whileElementsMounted: autoUpdate,
  })

  const hover = useHover(context, {
    delay: { open: delay, close: 0 },
    enabled: !disabled,
  })

  const { getReferenceProps, getFloatingProps } = useInteractions([hover])

  const staticSide = {
    top: 'bottom',
    right: 'left',
    bottom: 'top',
    left: 'right',
  }[placement.split('-')[0]]

  if (disabled || !content) {
    return children
  }

  return (
    <>
      {cloneElement(children, {
        ref: refs.setReference,
        ...getReferenceProps(),
        className: clsx(styles.tooltipTrigger, children.props?.className),
      })}
      {isVisible && (
        <div
          ref={refs.setFloating}
          //
          {...getFloatingProps()}
          //
          className={clsx(
            'animate__animated animate__fadeIn animate__faster',
            styles.tooltipContent
          )}
          style={{
            ...floatingStyles,
            width: customWidth || 'auto',
            zIndex: 1000,
          }}
        >
          <div>{content}</div>
          <div
            ref={arrowRef}
            className={styles.tooltipArrow}
            style={{
              left:
                middlewareData.arrow?.x != null
                  ? `${middlewareData.arrow.x}px`
                  : '',
              top:
                middlewareData.arrow?.y != null
                  ? `${middlewareData.arrow.y}px`
                  : '',
              [staticSide]: '-4px',
            }}
          />
        </div>
      )}
    </>
  )
}
